var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.authorized)?_c('v-container',{staticClass:"body pa-0",attrs:{"fluid":""}},[(!_vm.loading)?_c('router-view',{staticClass:"body"}):_vm._e()],1):_c('v-container',{staticClass:"body d-flex align-center justify-center",attrs:{"fluid":""}},[_c('v-card',{staticClass:"text-center",attrs:{"flat":""}},[_c('v-icon',{staticClass:"mb-4",attrs:{"size":"200"}},[_vm._v("fal fa-ban")]),_c('v-card-title',{domProps:{"innerHTML":_vm._s(
                _vm.getComplexTranslations(
                    `language_fe_errors.unauthenticated${_vm.token ? '.token' : ''}`
                )
            )}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }